import React from "react";
import close from "../../../assets/Icons/close.png"
import aiError from "../../../assets/simmetry/simAiError.png"

const ServerBusyPopup = ({ onClose }) => {
    return (
        <div className="h-full z-20 absolute w-full top-0 bg-black/[0.3] backdrop-blur-sm flex items-end">
            <div className="h-full w-full absolute top-0 z-10 bg-black/[0.4] backdrop-blur-sm flex justify-center items-center" >
                <div className="bg-white rounded-xl py-7 px-5 w-10/12 ">
                    <div className="flex pt-4 justify-center items-start relative">
                        <img src={aiError} alt="Error" className=" h-24 sm600:h-48 md:h-48" />
                        <button onClick={() => {
                            onClose()
                        }} className="absolute top-2 right-2">
                            <img src={close} alt="close" className=" h-5 sm600:h-10 md:h-10" />
                        </button>
                    </div>
                    <p className=" text-center  font-jost text-xl text-[#011E41]  py-4 font-medium text-[17px] tracking-[4%] md:text-2xl">SERVER BUSY!</p>

                    <div className="font-jost text-base text-[#022022] p-4 text-center" >
                        <p className=" text-base text-[#022022] font-jost md:text-2xl">                    Please try again after 20-30 seconds. The server is busy.
                        </p>

                    </div>
                    <div className="flex flex-col items-center mt-3">

                        <button
                            type="button"
                            className=" w-52  rounded-full  text-white bg-[#011E41]   font-jost py-4 px-2 md:w-60  font-medium text-[17px] tracking-[4%] md:text-2xl"
                            onClick={() => {
                                onClose(true)
                            }}>
                            Try Again...
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )

};

export default ServerBusyPopup;
